"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RatingAndReviewDialog = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _api = require("../../api");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _Loading = require("../Loading");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Content = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require('./components')))).Content
}));
/**
 * Shows Rating and Review dialog.
 */
const RatingAndReviewDialog = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const theme = (0, _mui.useTheme)();
  const {
    open,
    reviewId,
    onClose
  } = (0, _contexts.useRatingAndReviewDialog)();
  const {
    loading
  } = (0, _api.useGetReview)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const content = (0, _react.useMemo)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}),
    children: loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(Content, {})
  }), [loading]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledDialog, {
    disableEnforceFocus: true,
    "data-testid": getTestId(_constants.RATING_AND_REVIEW_DIALOG),
    zIndex: theme.zIndex.modal,
    open: open,
    header: reviewId ? translations.mainEditTitle : translations.mainTitle,
    size: "small",
    transitionProps: _constants.transitionProps,
    maxWidth: "960px",
    onClose: onClose,
    children: content
  });
};
exports.RatingAndReviewDialog = RatingAndReviewDialog;
